import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { DataproviderService } from '../dataprovider.service';
import { WebcallsService } from '../webcalls.service';
import { NavigatorService } from '../shared/navigator/navigator.service';

@Component({
  selector: 'app-reject',
  templateUrl: './reject.component.html',
  styleUrls: ['./reject.component.scss', "./reject.component.responsive.scss"]
})
export class RejectComponent implements OnInit {
  hostName: string = window.location.hostname;
  uuid: string = '';
  token: string = '';
  formGroup: FormGroup;
  validUuid: boolean = false;
  loaded: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private ws: WebcallsService,
    private fb: FormBuilder,
    private ns: NavigatorService,
    private dp: DataproviderService
    ) {
    this.formGroup = this.fb.group({
      // Add your form controls and validation rules here
      UUIDField: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.ws.setBaseUrl(this.hostName);
    this.wsCall();

    this.formGroup = this.fb.group({
      UUIDField: ['', [Validators.required, this.validateCompleteInput]],
    });
  }

  validateCompleteInput(control: AbstractControl) {
    if (this && this.formGroup && this.formGroup.get('inputUUID')) {
      const myInputFieldControl = this.formGroup.get('inputUUID');
      if (myInputFieldControl && myInputFieldControl.invalid) {
        // handle invalid control
        if(control.value && control.value.length === 13) { // adjust the length check as needed
          return null; // input is valid
        } else {
          return { 'incompleteInput': true }; // input is invalid
        }
      }
    }
  }

  wsCall() {
    let host = this.hostName != "localhost" ? this.hostName : "http://casab2c.demorooms.com";
    this.ws.getLocalization(host).subscribe(data => {
      this.dp.setLocalization(data);
      // this.dp.resetDataProvider();
      // this.dp.getFinishings(data["ID"]);
      // this.dp.getCoverData(data["ID"]);

      // this.dp.preloadDataSkippedPage();

      this.route.params.subscribe(
        (params: Params) => {
          if (params['uuid']) {
            this.uuid = params['uuid'];
          }
          if (params['token']) {
            this.token = params['token'];
          }
        }
      );
    });
  }
  wsCallCheckUUID(uuid: string){
    var that = this;
    this.ws.getQuotationByUUID(uuid, 12).subscribe(data => {
      //that.dp.reloadQuotationParams(data);
      this.validUuid = true;
      this.loaded = true;
    }, error => {
      this.validUuid = false;
      this.loaded = false;
    });
  }
  onFocusOutEvent(){
    var that = this;
    var pattern = new RegExp('^[0-9A-Z]{6}-[0-9A-Z]{6}$');
    if (this.uuid.match(pattern)){
      this.validUuid = true;
      that.wsCallCheckUUID(this.uuid);
      this.dp.setUUID(this.uuid);
    } else {
      this.validUuid = false;
    }
  }

  customMask = {
    mask: this.customMaskFunc
  }

  customMaskFunc(value: string) {
    var that = this;
    if (value.length == 13){
      var pattern = new RegExp('^[0-9A-Z]{6}-[0-9A-Z]{6}$');
      return value.match(pattern);
    } else {
      return true;
    }
  };


  btnRifiuta() {
    let host = window.location.hostname != "localhost" ? window.location.hostname : "http://casab2c.demorooms.com";
    var that = this;
    this.ws.rejectQuotation(this.uuid, this.token, host).subscribe(data => {
      if (data)
      {
        let result = data["StateMailUser"];
        if (result === 'mail sent')
        {
          this.ns.navigateRoute("reject/thanks");
        }
      }
    }, error => {
      console.log('Si è verificato un errore:', error);
      return error;
    });
    ;
  }

}
